import { useEffect } from 'react';
import { decodeToken } from 'react-jwt';
import _, { isNull } from 'lodash';
import { useStateValue } from '../providers/StateProvider';

const useUserInfo = () => {
    const [, dispatch] = useStateValue();

    useEffect(() => {
        if (localStorage.getItem('token')) {
            const info = decodeToken(localStorage.getItem('token'))?.result;
            if (!_.has(info, 'verificado') && info?.userLvl === 1) {
                localStorage.clear();
                dispatch({ type: 'DELETE_USER_INFO' });
            } else {
                dispatch({
                    type: 'ADD_USER_INFO',
                    item: {
                        user: info?.userLvl === 1 && info?.entidad,
                        name: info?.nombre,
                        mail: info?.correo,
                        id: info?.id,
                        lvl: info?.userLvl,
                        depto: info?.id_direccion,
                        priv: info?.privilegio,
                        privilegios: info?.privilegios,
                        puesto: info?.puesto,
                        phone: info?.telefono,
                        prorrogas: info?.prorrogas,
                        contratos: info?.contratos,
                        multas: info?.multas,
                        puestoNombre: info?.puesto_nombre,
                        entidad: info?.nombre_completo,
                        estatus: info?.eliminado,
                        verificado: info?.verificado,
                        tokenFirebase: localStorage.getItem('tf'),
                        avisoPrivacidad: !isNull(localStorage.getItem('avisoPrivacidad')) ? localStorage.getItem('avisoPrivacidad') === 'true' : true,
                    },
                });
            }
        }
    }, []);
    useEffect(() => {
        if (localStorage.getItem('tf') && localStorage.getItem('tf') !== 'null') {
            dispatch({
                type: 'ADD_TOKEN_FIREBASE',
                item: localStorage.getItem('tf'),
            });
        }
    }, []);
};
export default useUserInfo;
